import React, { useState, useEffect, useMemo } from "react";
import { useSearchQuery, usePagination } from "../../../hooks";
import { MPSharedTable, MPSharedDeleteModal, MPSharedHeader } from "../Shared";
import { useGetVManModelVariantsQuery, useDeleteVManModelVariantMutation } from "../services";
import { VManModelVariantForm } from "./form";
import { useDelete } from "../../../hooks";
import { getLocalizedString } from "../../../shared/translation";

export const VManModelVariantContainer = () => {
  const { page, setPage, perPage, pagination } = usePagination();

  const { setSimpleSearch, setAdvanceSearch, q } = useSearchQuery({
    page,
    setPage,
    simpleSearchKey: "name_cont",
  });

  const {
    data = { data: [], total_count: 0 },
    error,
    isFetching,
    isSuccess,
  } = useGetVManModelVariantsQuery({
    page,
    per_page: perPage,
    order_by: "created_at",
    order_dir: "desc",
    q,
  });

  const {
    deleteItem: deleteVManModelVar,
    deleteErrorMsg,
    setDeleteErrorMsg,
  } = useDelete({
    deleteMutation: useDeleteVManModelVariantMutation,
    closeModal: () => setShowDeleteWarning(false),
  });

  const [showDeleteWarning, setShowDeleteWarning] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [idToDelete, setIdToDelete] = useState(null);
  const [idToEdit, setIdToEdit] = useState(null);

  const onEdit = (datum) => {
    setShowForm(true);
    setIdToEdit(datum.id);
  };

  const onDelete = (datum) => {
    setShowDeleteWarning(true);
    setIdToDelete(datum.id);
  };

  const onCreate = () => {
    setShowForm(true);
    setIdToEdit(null);
  };

  const headers = [
    {
      label: getLocalizedString("name", "Name"),
      key: "name",
      className: "name",
    },
    {
      label: getLocalizedString("manufacturer", "Manufacturer"),
      key: "vehicle_manufacturer_name",
      className: "vehicle-manufacturer-name",
    },
    {
      label: getLocalizedString("manufacturer_model", "Manufacturer Model"),
      key: "vehicle_manufacturer_model_name",
      className: "vehicle-manufacturer-model-name",
    },
    {
      label: getLocalizedString("added_on", "Added On"),
      key: "created_at",
      className: "date",
    },
  ];

  const getDeleteItemName = (id) => {
    let name = "";
    const index = data?.data?.findIndex((item) => item.id === id);
    if (index >= 0) {
      name = data?.data[index]?.name;
    }
    return name;
  };

  return (
    <>
      <article className="main-container">
        <MPSharedHeader
          groupName="vehicle"
          heading={getLocalizedString("vehicles", "Vehicles")}
          createNewHandler={onCreate}
          resourceName="Vehicle Manufacturer Model Variants"
          handleSearchKey={(value) => setSimpleSearch(value)}
          simpleSearchPlaceholder={getLocalizedString("search_by_name", "Search by Name")}
        />

        <MPSharedTable
          resourceName="Vehicle Manufacturer Model Variants"
          data={data.data || []}
          error={error}
          isLoading={isFetching}
          isSuccess={isSuccess}
          headers={headers}
          onDelete={onDelete}
          onEdit={onEdit}
          pagination={{ ...pagination, count: data.total_count }}
          className="vehicle-variants"
          auditResource="VehicleManufacturerModelVariant"
          auditKey="name"
        />
      </article>

      <MPSharedDeleteModal
        show={showDeleteWarning}
        entityName={getLocalizedString(
          "vehicle_manufacturer_model_variant",
          "Vehicle Manufacturer Model Variant"
        )}
        error={deleteErrorMsg}
        onHide={() => {
          setDeleteErrorMsg("");
          setShowDeleteWarning(false);
        }}
        itemName={getDeleteItemName(idToDelete)}
        onDelete={() => deleteVManModelVar({ id: idToDelete })}
      />
      {showForm && <VManModelVariantForm idToEdit={idToEdit} onClose={setShowForm} />}
    </>
  );
};
